/// <amd-module name="Artifacts/Root/helpers/FeedHelpers" />

import { ciEquals } from "Artifacts/Root/StringTools";
import { IFeed } from "Artifacts/Root/types";
import { ViewIdentifier } from "Artifacts/Root/types/AzureArtifacts";

export function getFeedIdentifier(feed: IFeed, view?: ViewIdentifier): string {
  return view ? `${feed.name}@${view.name}` : feed.name;
}

export function getViewIdentifier(feedIdentifier: string): string {
  const splitIdentifier = feedIdentifier.split("@");
  return splitIdentifier.length > 1 ? splitIdentifier[1] : "";
}

export function isSameFeedView(fullyQualifiedFeedIdentifier: string, feed: IFeed): boolean {
  return (
    isSameFeed(fullyQualifiedFeedIdentifier, feed) && isSameView(fullyQualifiedFeedIdentifier, feed)
  );
}

export function isSameFeed(feedIdentifier: string, feed: IFeed): boolean {
  const feedNameOrId = feedIdentifier.split("@")[0] || feedIdentifier;

  return ciEquals(feed.id, feedNameOrId) || ciEquals(feed.name, feedNameOrId);
}

export function isSameView(feedIdentifier: string, feed: IFeed): boolean {
  const viewNameOrId = getViewIdentifier(feedIdentifier);
  const selectedView = getSelectedView(feed);
  return (
    ciEquals(selectedView?.name || "", viewNameOrId) ||
    ciEquals(selectedView?.id || "", viewNameOrId)
  );
}

export function getSelectedView(feed?: IFeed): ViewIdentifier | undefined {
  return feed?.selectedViewId ? getViewFromNameOrId(feed, feed?.selectedViewId) : undefined;
}

export function getViewFromNameOrId(
  feed?: IFeed,
  viewIdentifier?: string,
): ViewIdentifier | undefined {
  return feed?.views.find(
    (view) => ciEquals(view.id, viewIdentifier || "") || ciEquals(view.name, viewIdentifier || ""),
  );
}

/**
 * Generate new fully qualified feed name with the provided view
 * @param fullyQualifiedFeed string representing a fully qualified feed (ids or names, view or base feed)
 * @param viewNameOrId string representing the view name or id
 * @returns
 */
export function getFeedNameWithNewView(fullyQualifiedFeed: string, viewNameOrId?: string): string {
  const [feedNameOrId] = fullyQualifiedFeed.split("@");
  return viewNameOrId ? `${feedNameOrId}@${viewNameOrId}` : feedNameOrId;
}

export function isPublicFeed(feed: IFeed | undefined): boolean {
  if (!feed || !feed.project) {
    return false;
  }

  return feed.project.visibility === "Public";
}
